import { render, staticRenderFns } from "./NotenausgabeSVModal.vue?vue&type=template&id=0f658240&"
import script from "./NotenausgabeSVModal.vue?vue&type=script&lang=js&"
export * from "./NotenausgabeSVModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports